import React, { useState, useEffect } from "react";

import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setChatSettings } from "../../../../appRedux/actions/ChatSettings";
import { useIntl } from "react-intl";

import IntlMessages from "@util/IntlMessages";
import { showName } from "@util/Scripts";
import { useWidgetSettings } from "@util/customHooks";

import "../ChatSettings/ChatStyle.less";
import { Message, Switch, Button, Spin, Input } from "../../../BP2Components";
import { Icon_Plus } from "../../../BP2Components/Icons/icons";

const ListChatSettings = (props) => {
   const [usersToAdd, setUsersToAdd] = useState(() =>
      (props?.chatUsersColumnTechNames ?? []).map((element, index) => ({
         index,
         columnName: element?.columnTechName,
         type: element?.type,
      })),
   );
   const selectOptions = [];

   const { allLanguages, locale } = useSelector(({ settings }) => settings);
   const serviceTranslations = useSelector(({ translations }) => translations.translations);

   const dispatch = useDispatch();
   const intl = useIntl();
   const {
      settings: chatActionSettings,
      setSettings: setChatActionSettings,
      syncTranslations,
   } = useWidgetSettings(
      {
         chatButtonTitle: props?.chatButtonTitle,
         chatBtnVisible: props?.showChatButton,
         titleTechName: props?.title,
         subTitleTechName: props?.subTitle,
         usersTechName: props?.chatUsersColumnTechNames,
      },
      {
         sync: [{ keyField: "chatButtonTitle", category: "list.name", valuePrefix: "name" }],
         translations: [{ translationKey: props?.chatButtonTitle }],
      },
   );

   const [newBoard, setNewBoard] = useState({ ...props.board });

   useEffect(() => {
      const boardEntry = props?.board?.translations?.find((t) => t.key === props?.chatButtonTitle);
      const nameUpdates = allLanguages.reduce((acc, { language }) => {
         const serviceVal =
            language === locale ? serviceTranslations?.[props?.chatButtonTitle] : null;
         acc[`name${language}`] = serviceVal || boardEntry?.values?.[language];
         return acc;
      }, {});
      setChatActionSettings((prev) => ({ ...prev, ...nameUpdates }));
   }, []);

   const saveChatSettings = () => {
      const changedSettings = { ...props.board };
      const requiredWidget = newBoard?.sheets
         ?.find((sheet) => sheet?.widgets?.find((widget) => widget?.id == props?.id))
         ?.widgets?.find((widget) => widget?.id == props?.id);
      requiredWidget.showChatButton = chatActionSettings?.chatBtnVisible;
      requiredWidget.chatTitle = chatActionSettings?.titleTechName;
      requiredWidget.chatSubTitle = chatActionSettings?.subTitleTechName;
      requiredWidget.chatUsersColumnTechNames = usersToAdd.map((item) => {
         return {
            columnTechName: `${item?.columnName}`,
            type: item?.type,
         };
      });

      const findTranslation = newBoard.translations.find(
         (item) => item.key == props?.chatButtonTitle,
      );

      if (findTranslation) {
         findTranslation.values = allLanguages.reduce((target, key) => {
            target[key.language] = Object.entries(chatActionSettings).find(
               (item) => item[0] == `name${key.language}`,
            )[1];
            return target;
         }, {});
      } else {
         newBoard.translations.push({
            category: null,
            key: chatActionSettings?.chatButtonTitle,
            values: allLanguages.reduce((target, key) => {
               target[key.language] = Object.entries(chatActionSettings).find(
                  (item) => item[0] == `name${key.language}`,
               )[1];
               return target;
            }, {}),
         });
      }

      setNewBoard({ ...changedSettings });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setChatSettings(chatActionSettings));
      saveChatSettings(chatActionSettings);
      syncTranslations(chatActionSettings);
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleSwitch = (checked, name) => {
      setChatActionSettings({ ...chatActionSettings, [name]: checked });
   };

   const handleChangeInput = (event, name) => {
      setChatActionSettings({ ...chatActionSettings, [name]: event.target.value });
   };

   const handleSelectTitle = (selectedTitle) => {
      setChatActionSettings({ ...chatActionSettings, titleTechName: selectedTitle });
   };

   const handleSelectSubTitle = (selectedSubTitle) => {
      setChatActionSettings({ ...chatActionSettings, subTitleTechName: selectedSubTitle });
   };

   const handleSelectUsers = (selectedUser, index) => {
      let requiredColumns = [...usersToAdd];
      requiredColumns.find((item) => item?.index == index).columnName = selectedUser;
      setUsersToAdd(requiredColumns);
   };

   if (props) {
      props?.columns?.forEach((column, idx) => {
         if (column.title !== undefined) {
            selectOptions.push(
               <Select.Option key={idx} value={column.dataIndex}>
                  {column.title}
               </Select.Option>,
            );
         }
      });
   }

   const addColumn = () => {
      setUsersToAdd([...usersToAdd, { index: usersToAdd?.length, columnName: "" }]);
   };

   const deleteColumn = (e) => {
      setUsersToAdd(usersToAdd.filter((value) => value !== e));
   };
   const setUserToOwner = (e) => {
      //finding column to change type to owner
      let userIndex = usersToAdd?.find((value) => value?.index === e?.index)?.index;

      // deleting all type of "owners"
      const deleteAllOwners = usersToAdd.map((elem) =>
         elem.type === "owner" ? { ...elem, type: "user" } : elem,
      );

      // setting new owner
      const newOwner = deleteAllOwners.map((elem) =>
         elem.index === userIndex ? { ...elem, type: "owner" } : elem,
      );
      setUsersToAdd(newOwner);
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label key="chatBtnVisible" className="widget-settings__inner__label">
                     <IntlMessages id="Show chat button" />:
                     <Switch
                        name="chatBtnVisible"
                        onChange={(e) => handleSwitch(e, "chatBtnVisible")}
                        defaultChecked={chatActionSettings?.chatBtnVisible}
                     />
                  </label>

                  <label className="widget-settings__inner__label">
                     <IntlMessages id="Chat name" />:
                     <Input
                        style={{ width: "400px" }}
                        name="chatTitle"
                        defaultValue={chatActionSettings?.chatButtonTitle}
                        disabled
                     />
                  </label>

                  {allLanguages?.map((item) => (
                     <label
                        className="widget-settings__inner__label"
                        key={item.language}
                        style={{ marginLeft: "60px" }}
                     >
                        <IntlMessages id={`Chat name ${item.language}`} />:
                        <Input
                           style={{ width: "350px" }}
                           type="translation"
                           name={`name${item.language}`}
                           defaultValue={
                              chatActionSettings[`name${item.language}`]
                                 ? chatActionSettings[`name${item.language}`]
                                 : showName(
                                      `${item.language}`,
                                      chatActionSettings.chatButtonTitle,
                                      chatActionSettings,
                                   )
                           }
                           onChange={(e) => handleChangeInput(e, `name${item.language}`)}
                        />
                     </label>
                  ))}

                  <label style={{ marginLeft: "30px" }} className="widget-settings__inner__label">
                     <IntlMessages id="chat.list.settings.title" />:
                     <Select
                        defaultValue={chatActionSettings?.titleTechName}
                        style={{ width: "400px" }}
                        onChange={(e) => handleSelectTitle(e)}
                     >
                        {selectOptions === undefined ? <Spin /> : selectOptions}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" style={{ marginLeft: "8px" }}>
                     <IntlMessages id="settings.subtitleAdvertismentList" />:
                     <Select
                        defaultValue={chatActionSettings?.subTitleTechName}
                        style={{ width: "400px" }}
                        onChange={(e) => handleSelectSubTitle(e)}
                     >
                        {selectOptions === undefined ? <Spin /> : selectOptions}
                     </Select>
                  </label>
                  {usersToAdd?.length !== 0 ? (
                     <div style={{ marginLeft: "70px" }} className="item-content-rows-list">
                        <div style={{ width: "601px" }} className="item-content-row-container">
                           <div className="item-content-columns-list">
                              {usersToAdd?.map((column, index) => {
                                 return (
                                    <div
                                       style={{ width: "587px" }}
                                       className="item-content-column-container"
                                    >
                                       <div className="item-content-column-name">
                                          <IntlMessages id="chat.settings.addUser" />
                                       </div>
                                       <Select
                                          style={{ width: "383px" }}
                                          onChange={(e) => handleSelectUsers(e, index)}
                                          defaultValue={
                                             selectOptions.find(
                                                (item) => item.props.value == column.columnName,
                                             )?.props.children
                                          }
                                       >
                                          {selectOptions === undefined ? (
                                             <Spin />
                                          ) : (
                                             selectOptions.filter(
                                                (item) =>
                                                   item.props.value !=
                                                   usersToAdd?.find(
                                                      (column) =>
                                                         column.columnName == item.props.value,
                                                   )?.columnName,
                                             )
                                          )}
                                       </Select>
                                       <div>
                                          <Button
                                             className={
                                                column?.type === "owner" ? "ant-btn-primary" : null
                                             }
                                             onClick={() => setUserToOwner(column)}
                                          >
                                             <IntlMessages id="chat.isOwner" />
                                          </Button>
                                          <Button
                                             onClick={() => {
                                                deleteColumn(column);
                                             }}
                                             buttonType="danger"
                                          >
                                             <i className=" icon icon-trash" />
                                          </Button>
                                       </div>
                                    </div>
                                 );
                              })}
                           </div>
                        </div>
                     </div>
                  ) : null}
                  <Button
                     buttonType="primary"
                     style={{ marginLeft: "70px", marginBottom: "20px", width: "150px" }}
                     onClick={() => addColumn()}
                  >
                     <Icon_Plus />
                     {usersToAdd?.length !== 0 ? "Add Another User" : "Add User"}
                  </Button>
               </div>

               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};
export default ListChatSettings;
